const initLinkedSizeProducts = (container = document) => {
  const controls = container.querySelectorAll('[data-linked-size-products-control]');
  if (!controls.length) return;

  controls.forEach((control) => {
    if (control.dataset.linkedSizeProductsInitialized === 'true') return;

    const select = control.querySelector('[data-linked-size-products]');
    if (!select) return;

    select.addEventListener('change', () => {
      if (select.value && select.value !== select.dataset.currentProductUrl) {
        window.location.assign(select.value);
      }
    });

    control.dataset.linkedSizeProductsInitialized = 'true';
  });
};

export default initLinkedSizeProducts;
